module.exports = __webpack_public_path__ + "static/media/banner-campo.cda331a2.jpg";